export const EMAILS = {
  support: 'support@lottolens.io',
  report: 'report@lottolens.io',
} as const;
